module.exports = __webpack_public_path__ + "static/media/favicon.f7ba7302.ico";